// extracted by mini-css-extract-plugin
module.exports = {"container":"InputWithDataType_container__oEOEn","dataTypeContainer":"InputWithDataType_dataTypeContainer__3xRwQ"};